//#region react import
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
//#endregion

//#region components import
import AcreosSelect from "../AcreosSelect/AcreosSelect.component";
//#endregion

//#region functions import
import { SetDataTestId } from "../../Helper/DataTestId";
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region store import
//#endregion

//#region constants import
import { FIREFOX_VERSIONS } from "../../Constants/BrowserConstants";
import {
  ICON_BUTTON,
  ICON_KEYBOARD_ARROW_LEFT,
  ICON_KEYBOARD_ARROW_RIGHT,
  ICON_KEYBOARD_DOUBLE_ARROW_LEFT,
  ICON_KEYBOARD_DOUBLE_ARROW_RIGHT,
} from "../../Constants/IconConstants";
import { TRANSLATIONS } from "../../Constants/Translations";
//#endregion

//#region style import
import "./GstaTablePagination.style.scss";
//#endregion

const GstaTablePagination = ({
  elementPerPage,
  setElementPerPage,
  totalElementsCount,
  numberPerPageText,
  pageNumber,
  setPageNumber,
}) => {
  //#region state
  const [toBottom, setToBottom] = useState(false);
  //#endregion

  //#region constants
  const finalTotalElementsCount = totalElementsCount === 0 || undefined ? 1 : totalElementsCount;
  const numberOfPages = Math.ceil(finalTotalElementsCount / elementPerPage);
  //#endregion

  //#region others use...
  const translations = useSelector((state) => state.translationSlice.translations);
  //#endregion

  //#region functions
  const handleChangeElementPerPage = (value) => {
    const newNumberOfPages = Math.ceil(finalTotalElementsCount / value);
    const newPage = Math.min(newNumberOfPages, pageNumber);
    setPageNumber(newPage);
    setElementPerPage(value);
  };

  const handleNextPageClick = () => {
    const nextPage = Math.min(numberOfPages, pageNumber + 1);
    setPageNumber(nextPage);
    setToBottom(true);
  };

  const handlePreviousPageClick = () => {
    const nextPage = Math.max(0, pageNumber - 1);
    setPageNumber(nextPage);
    setToBottom(true);
  };

  const handleSetPageToFirstPage = () => {
    setPageNumber(0);
    setToBottom(true);
  };

  const handleSetPageToLastPage = () => {
    setPageNumber(numberOfPages - 1);
    setToBottom(true);
  };
  //#endregion

  //#region useQuery
  //#endregion

  const ref = useRef();
  //#region useEffect

  useEffect(() => {
    if (toBottom) {
      ref.current.scrollIntoView && ref.current.scrollIntoView();
      setToBottom(false);
    }
  }, [toBottom]);
  //#endregion
  return (
    <div
      className={"gsta-table-pagination-container"}
      ref={ref}
      firefox_compatibility={new RegExp(FIREFOX_VERSIONS).test(navigator.userAgent).toString()}
    >
      <div className="gsta-table-pagination-select-element-per-page">
        <span>{getTranslations(numberPerPageText, translations)}</span>
        <AcreosSelect
          setNewValue={handleChangeElementPerPage}
          options={[
            { label: 10, value: 10 },
            { label: 20, value: 20 },
            { label: 30, value: 30 },
          ]}
          value={elementPerPage}
          isValid
          dataTestId="pagination"
        />
      </div>
      <div className="gsta-table-pagination-select-page">
        <div>
          {`${pageNumber * elementPerPage + 1} -
              ${Math.min((pageNumber + 1) * elementPerPage, finalTotalElementsCount)}

              ${getTranslations(TRANSLATIONS.STUDENT_PAGINATION_ON, translations)}
              
              ${finalTotalElementsCount}`}
        </div>
        <div>
          <button
            className={ICON_BUTTON}
            onClick={handleSetPageToFirstPage}
            disabled={pageNumber === 0}
            data-testid={SetDataTestId("first-page-button")}
          >
            <i className={ICON_KEYBOARD_DOUBLE_ARROW_LEFT} />
          </button>
        </div>
        <div>
          <button
            className={ICON_BUTTON}
            onClick={handlePreviousPageClick}
            disabled={pageNumber === 0}
            data-testid={SetDataTestId("previous-page-button")}
          >
            <i className={ICON_KEYBOARD_ARROW_LEFT} />
          </button>
        </div>
        <div>
          {`${getTranslations(TRANSLATIONS.STUDENT_PAGINATION_PAGE, translations)}

              ${pageNumber + 1}

              ${getTranslations(TRANSLATIONS.STUDENT_PAGINATION_ON, translations)}

              ${numberOfPages}`}
        </div>
        <div>
          <button
            className={ICON_BUTTON}
            onClick={handleNextPageClick}
            disabled={pageNumber + 1 === numberOfPages}
            data-testid={SetDataTestId("next-page-button")}
          >
            <i className={ICON_KEYBOARD_ARROW_RIGHT} />
          </button>
        </div>
        <div>
          <button
            className={ICON_BUTTON}
            onClick={handleSetPageToLastPage}
            disabled={pageNumber + 1 === numberOfPages}
            data-testid={SetDataTestId("last-page-button")}
          >
            <i className={ICON_KEYBOARD_DOUBLE_ARROW_RIGHT} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GstaTablePagination;
